import {
  USER_GET_REQUEST,
  USER_GET_REQUEST_FAILED,
  USER_GET_REQUEST_SUCCESS,
  COMPANY_PLAN_GET_REQUEST,
  COMPANY_PLAN_GET_REQUEST_FAILED,
  COMPANY_PLAN_GET_REQUEST_SUCCESS,
  PLANS_GET_REQUEST,
  PLANS_GET_REQUEST_FAILED,
  PLANS_GET_REQUEST_SUCCESS,
  SUBSCRIPTION_UPDATE_REQUEST,
  SUBSCRIPTION_UPDATE_REQUEST_FAILED,
  SUBSCRIPTION_UPDATE_REQUEST_SUCCESS,
  PAYMENT_GET_CARDS,
  PAYMENT_GET_CARDS_FAILED,
  PAYMENT_GET_CARDS_SUCCESS,
  PROFILES_GET_REQUEST,
  PROFILES_GET_REQUEST_FAILED,
  PROFILES_GET_REQUEST_SUCCESS,
  PAYMENT_GET_STATISTICS,
  PAYMENT_GET_STATISTICS_FAILED,
  PAYMENT_GET_STATISTICS_SUCCESS,
  // PROFILE_REMOVE_REQUEST,
  // PROFILE_REMOVE_REQUEST_FAILED,
  // PROFILE_REMOVE_REQUEST_SUCCESS,
  // PROFILE_EDIT_REQUEST,
  // PROFILE_EDIT_REQUEST_FAILED,
  // PROFILE_EDIT_REQUEST_SUCCESS,
  USER_ACTIVATED
} from "../constants";

const initialState = {
  user: {},
  companyPlan: {},
  plans: [],
  cards: [],
  profiles: [],
  stats: {
    usersAmount: "0",
    maxUsersAmount: "0",
    pushesAmount: "0",
    maxPushesAmount: "0",
    audiencesAmount: "0",
    daysLeft: "0",
    clientsAmount: "0"
  },
  paymentHistory: [],
  isLoading: false,
  error: {},
  message: ""
};

export default (state = initialState, action) => {
  switch (action.type) {
    case USER_GET_REQUEST:
    case COMPANY_PLAN_GET_REQUEST:
    case PLANS_GET_REQUEST:
    case SUBSCRIPTION_UPDATE_REQUEST:
    case PAYMENT_GET_CARDS:
    case PROFILES_GET_REQUEST:
    case PAYMENT_GET_STATISTICS:
      return {
        ...state,
        error: {},
        isLoading: true
      };
    case USER_GET_REQUEST_FAILED:
    case COMPANY_PLAN_GET_REQUEST_FAILED:
    case PLANS_GET_REQUEST_FAILED:
    case SUBSCRIPTION_UPDATE_REQUEST_FAILED:
    case PAYMENT_GET_CARDS_FAILED:
    case PROFILES_GET_REQUEST_FAILED:
    case PAYMENT_GET_STATISTICS_FAILED:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    case USER_GET_REQUEST_SUCCESS:
      return {
        ...state,
        user: action.payload,
        isLoading: false,
        error: {}
      };
    case COMPANY_PLAN_GET_REQUEST_SUCCESS:
      return {
        ...state,
        companyPlan: action.payload[0],
        isLoading: false,
        error: {}
      };
    case PLANS_GET_REQUEST_SUCCESS:
      return {
        ...state,
        plans: [...action.payload],
        isLoading: false,
        error: {}
      };
    case SUBSCRIPTION_UPDATE_REQUEST_SUCCESS:
      return {
        ...state,
        user: {
          ...state.user,
          company: {
            ...state.user.company,
            currentSubscription: action.payload.subscriptionPlan
          }
        },
        companyPlan: action.payload,
        isLoading: false,
        error: {}
      };
    case PAYMENT_GET_CARDS_SUCCESS:
      return {
        ...state,
        cards: action.payload
      };
    case PAYMENT_GET_STATISTICS_SUCCESS:
      return {
        ...state,
        stats: action.payload
      };
    case PROFILES_GET_REQUEST_SUCCESS:
      return { ...state, profiles: action.payload };
    case USER_ACTIVATED:
      return {
        ...state,
        message: action.payload
      };
    default:
      return state;
  }
};
